const activeStatus = [
  { text: "Active", value: "active" },
  { text: "In-Active", value: "inactive" },
];

const amountsAre = [
  { text: "Tax Exclusive", value: 1 },
  { text: "Tax Inclusive", value: 2 },
  { text: "No Tax", value: 3 },
];

const branding = [
  { text: "Standard", value: 1 },
  { text: "Special Projects", value: 2 },
  { text: "Very Orange Invoice", value: 3 },
];

const spentAs = [
  { text: "Direct Payment", value: 1 },
  { text: "Pre Payment", value: 2 },
  { text: "Over Payment", value: 3 },
];
export { activeStatus, amountsAre, branding, spentAs };
